import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import lazysizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import {createFocusTrap} from 'focus-trap';

import {waitUntil, WAIT_FOREVER} from 'async-wait-until';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';
import * as Cart from './components/cart';

import SwiperCore, {A11y, Autoplay, Navigation, Pagination} from 'swiper/core';
SwiperCore.use([A11y, Autoplay, Navigation, Pagination]);

import {formatMoney} from '@shopify/theme-currency';
import {handleize, isInViewport} from './util/helper';

import { loadCatchjs } from '@get-catch/catchjs';

import '../css/theme.css';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.requireJs = function (modules, cb) {
  window.require(modules, cb);
};

lazySizes.cfg.nativeLoading = {
  setLoadingAttribute: true,
  disableListeners: {
    scroll: true,
  },
};

// Cleanup - Set global functionality
theme.formatMoney = (price, moneyFormat) => {
  return formatMoney(price, moneyFormat).replace('.00', '');
};
theme.Cart = Cart;

// Set sessionStorage based on the UTM parameters
const utmParams = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

const urlParams = new URLSearchParams(window.location.search);
const utmParamsObject = {};

for (const param of utmParams) {
  const paramValue = urlParams.get(param);
  if (paramValue) {
    utmParamsObject[param] = paramValue;
  }
}

if (Object.keys(utmParamsObject).length) {
  sessionStorage.setItem('utmParams', JSON.stringify(utmParamsObject));
}

// Get the session storage UTM params and set it to the object if empty
const sessionUtmParams = sessionStorage.getItem('utmParams');
if (sessionUtmParams) {
  const sessionUtmParamsObject = JSON.parse(sessionUtmParams);
  for (const param of utmParams) {
    if (!utmParamsObject[param] && sessionUtmParamsObject[param]) {
      utmParamsObject[param] = sessionUtmParamsObject[param];
    }
  }
}

if (utmParamsObject.utm_medium === 'podcast' && utmParamsObject.utm_source) {
  const helloBarSecondary = document.querySelector('.hello-bar__secondary');
  if (helloBarSecondary) {
    const message = `<p>Discount <strong>${utmParamsObject.utm_source}</strong> added! Get 15% off orders over $50.</p>`;
    setTimeout(() => {
      helloBarSecondary.classList.add('opacity-0');
      setTimeout(() => {
        helloBarSecondary.classList.remove('opacity-0');
        helloBarSecondary.innerHTML = message;
      }, 300);
    }, 800);
  }
}

// const currentUrl = new URL(window.location.href);
// const currentPath = currentUrl.pathname + currentUrl.hash;

// // Check for session storage "summer_sale" to see if it exists, if not set it to true
// const summerSale = sessionStorage.getItem('summer_sale');
// if (!summerSale) {
//   sessionStorage.setItem('summer_sale', true);

//   const discountCode = 'SUMMER';
//   const discountUrl = `/discount/${discountCode}?redirect=${currentPath}`;

//   // Redirect to the discount URL
//   window.location.href = discountUrl;
// }


/*
 * Expand/Collapse `aria-expanded`
 * ------------------------------------------------------------------
 * Set value of [data-expander-toggle], [data-expander-close] to value
 * of [data-expander-target] that you want to exapand/collapse.
 *
 */

// Expand the navigation dropdown menus
const desktopNavDropdowns = document.querySelectorAll('.nav__desktop li.group');
desktopNavDropdowns.forEach((element) => {
  const link = element.querySelector('a[aria-expanded]');
  link.addEventListener('click', (event) => {
    // Check if the element is focused
    if (document.activeElement === link) {

      if (event.type === "click" && event.clientX === 0 && event.clientY === 0) {
        // Touch/tap event
        event.preventDefault();
      }

      // Toggle aria-expanded state
      if (link.getAttribute('aria-expanded') == 'false') {
        link.setAttribute('aria-expanded', true);
      } else {
        link.setAttribute('aria-expanded', false);
      }
    }
  });

  link.addEventListener('keydown', (event) => {
    if (document.activeElement === link) {

      if (event.key === "Enter" || event.key === " ") {
        // Keyboard ENTER event
        event.preventDefault();

        // Toggle aria-expanded state
        if (link.getAttribute('aria-expanded') == 'false') {
          link.setAttribute('aria-expanded', true);
        } else {
          link.setAttribute('aria-expanded', false);
        }
      }
    }
  });

  element.addEventListener('focusout', (event) => {
    const activeElement = event.relatedTarget;

    // Check if active element exists inside the element
    if (!element.contains(activeElement)) {
      link.setAttribute('aria-expanded', false);
    }
  });
});

const mobileMenu = document.querySelector(
  '[data-expander-target="mobile-menu"]'
);
const backdrop = document.querySelector('.backdrop');

const mobileMenuTarget = document.querySelector(
  '[data-expander-target="mobile-menu"]'
);
const mobileMenuTrapFocus = createFocusTrap(mobileMenuTarget, {
  initialFocus: false,
  allowOutsideClick: true,
});

// Toggle aria-expanded state (for hamburger menu, menu sections)
function handleExpanderToggle(listener) {
  const target = document.querySelector(
    `[data-expander-target="${listener.getAttribute('data-expander-toggle')}"]`
  );


  // Add tabindex="-1" to the target and all focusable children
  const focusableElements = target.querySelectorAll(
    'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
  );
  focusableElements.forEach((el) => {
    el.setAttribute('tabindex', '-1');
  });
  target.setAttribute('tabindex', '-1');
  target.setAttribute('aria-hidden', 'true');

  listener.addEventListener('click', function (e) {

    const targetType = target.getAttribute('data-expander-target');

    e.preventDefault();
    if (target.getAttribute('aria-expanded') == 'false') {
      // set focusable elements to tabindex="0"
      focusableElements.forEach((el) => {
        el.setAttribute('tabindex', '0');
      });
      target.setAttribute('tabindex', '0');
      target.setAttribute('aria-hidden', 'false');

      if (targetType === 'mobile-menu') {
        mobileMenuTrapFocus.activate();
      } else if (targetType === 'search') {
        // searchTrapFocus.activate();
      }
      // target.activate();
      // mobileMenuTrapFocus.activate();
      target.setAttribute('aria-expanded', true);
      if (listener.getAttribute('data-backdrop')) showBackdrop();
      if (listener.getAttribute('data-backdrop') == 'transparent') {
        backdrop.classList.add('opacity-0');
      }
    } else {
      // set focusable elements to tabindex="-1"
      focusableElements.forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });
      target.setAttribute('tabindex', '-1');
      target.setAttribute('aria-hidden', 'true');

      // mobileMenuTrapFocus.deactivate();
      // target.deactivate();
      if (targetType === 'mobile-menu') {
        mobileMenuTrapFocus.deactivate();
      } else if (targetType === 'search') {
        searchTrapFocus.deactivate();
      }

      target.setAttribute('aria-expanded', false);
      if (listener.getAttribute('data-backdrop')) hideBackdrop();
    }
  });
}


// Close aria-expanded state (for collapse menu, close/back button, etc)
function handleExpanderClose(listener) {
  const target = document.querySelector(
    `[data-expander-target="${listener.getAttribute('data-expander-close')}"]`
  );
  const targetType = target.getAttribute('data-expander-target');

  // Add tabindex="-1" to the target and all focusable children
  const focusableElements = target.querySelectorAll(
    'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
  );

  listener.addEventListener('click', function (e) {
    e.preventDefault();


    // If target has aria-expanded, set to false
    if (target.getAttribute('aria-expanded') == 'true') {
      target.setAttribute('aria-expanded', false);
    }
    // If target has data-expanded, set to false
    if (target.getAttribute('data-expanded') == 'true') {
      target.setAttribute('data-expanded', false);
    }

    if (targetType === 'mobile-menu') {
      mobileMenuTrapFocus.deactivate();
      focusableElements.forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });
      target.setAttribute('tabindex', '-1');
      target.setAttribute('aria-hidden', 'true');
    } else if (targetType === 'search') {
      searchTrapFocus.deactivate();
      focusableElements.forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });
      target.setAttribute('tabindex', '-1');
      target.setAttribute('aria-hidden', 'true');
    } else if (targetType === 'cart') {
      Cart.closeCartDrawer();
    }

    // target.deactivate();
    hideBackdrop();
  });
}

// Expand/collapse toggles
const expanderToggles = document.querySelectorAll('[data-expander-toggle]');
expanderToggles.forEach((el) => {
  // Exclude cart
  if (el.dataset.expanderToggle === 'cart') return;

  handleExpanderToggle(el);
});

// Manually setup cart open for tracking
const cartButton = document.querySelector('a[data-expander-toggle="cart"]');
cartButton.addEventListener('click', (event) => {
  event.preventDefault();
  Cart.openCartDrawer();
});

// Close/Back buttons
const expanderCloses = document.querySelectorAll('[data-expander-close]');

expanderCloses.forEach((el) => {
  handleExpanderClose(el);
});

// ESC key event
document.addEventListener('keyup', function (e) {
  if (e.code == 'Escape') {
    const searchFlyout = document.querySelector(
      '[data-expander-target="search"]'
    );

    const cartFlyout = document.querySelector('[data-expander-target="cart"]');

    const ariaExpanded = document.querySelector(
      '[data-expander-target][aria-expanded="true"]'
    );
    if (ariaExpanded) {
      // console.log('backdrop click', ariaExpanded);
      ariaExpanded.setAttribute('aria-expanded', 'false');
      hideBackdrop();
    }
    const dataExpanded = document.querySelector(
      '[data-expander-target][data-expanded="true"]'
    );
    if (dataExpanded) {
      // console.log('backdrop click', dataExpanded);
      dataExpanded.setAttribute('data-expanded', 'false');
      hideBackdrop();
    }
  }
});

// Handle backdrop click to dismiss the backdrop and the expander target element
backdrop.addEventListener('click', (e) => {

  let targetType;
  let focusableElements;
  let expanded;

  const ariaExpanded = document.querySelector(
    '[data-expander-target][aria-expanded="true"]'
  );
  if (ariaExpanded) {
    ariaExpanded.setAttribute('aria-expanded', 'false');

    expanded = ariaExpanded;
  }
  const dataExpanded = document.querySelector(
  '[data-expander-target][data-expanded="true"]'
  );
  if (dataExpanded) {
    dataExpanded.setAttribute('data-expanded', 'false');

    expanded = dataExpanded;
  }

  targetType = expanded.getAttribute('data-expander-target');
  focusableElements = expanded.querySelectorAll(
    'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
  );

  focusableElements.forEach((el) => {
    el.setAttribute('tabindex', '-1');
  });
  expanded.setAttribute('tabindex', '-1');
  expanded.setAttribute('aria-hidden', 'true');

  if (targetType === 'mobile-menu') {
    mobileMenuTrapFocus.deactivate();
  } else if (targetType === 'search') {
    searchTrapFocus.deactivate();
  } else if (targetType === 'cart') {
    Cart.closeCartDrawer();
  }

  e.target.classList.add('hidden');
  // If #cart is in the URL, remove it
  if (window.location.hash === '#cart') {
    window.history.replaceState({}, '', window.location.pathname);
  }
});

function showBackdrop() {
  backdrop.classList.remove('hidden');
}

function hideBackdrop() {
  backdrop.classList.add('hidden');
  backdrop.classList.remove('opacity-0');
}

const checkCookieExists = (cookieName) => {
  const cookieString = `${cookieName}=`;
  const allCookies = document.cookie.split(';');

  for (let cookie of allCookies) {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieString) === 0) {
      return true;
    }
  }
  return false;
};

const initGoodbyeSalePopup = async () => {

  const goodbyeGate = document.querySelector('.goodbye-gate');
  goodbyeGate.classList.remove('hidden');
  goodbyeGate.classList.add('flex');

  const closeButton = goodbyeGate.querySelector('.goodbye-gate__close');
  const backdrop = goodbyeGate.querySelector('.goodbye-gate__backdrop');

  closeButton.addEventListener('click', () => {
    goodbyeGate.classList.add('hidden');
    goodbyeGate.classList.remove('flex');
    document.cookie = '_goodbye_sale=true;path=/';
  });

  backdrop.addEventListener('click', () => {
    goodbyeGate.classList.add('hidden');
    goodbyeGate.classList.remove('flex');
    document.cookie = '_goodbye_sale=true;path=/';
  });

  window.addEventListener('klaviyoForms', (event) =>{
    if (event.detail.type === 'submit' ||
        event.detail.type === 'stepSubmit') {
      document.cookie = '_goodbye_sale=true;path=/';
    }
  });

  window.addEventListener('klaviyoForms', (event) =>{
    if (event.detail.type === 'close') {
      goodbyeGate.classList.add('hidden');
      goodbyeGate.classList.remove('flex');
      document.cookie = '_goodbye_sale=true;path=/';
    }
  });
};

const goodbyeSaleCookie = checkCookieExists('_goodbye_sale');
const isGoodbyeKlaviyoDisabled = () => {
  let disabled = false;

  // check if klaviyoOnsite localstorage is set
  if (localStorage.getItem('klaviyoOnsite')) {
    const klaviyoOnsite = JSON.parse(localStorage.getItem('klaviyoOnsite'));
    // Check if klaviyoOnsite.viewedForms.modal.disabledForms is an empty object
    if (Object.keys(klaviyoOnsite.viewedForms.modal.disabledForms).length) {
      disabled = true;
    }
  }

  return disabled;
};
// If the url is /collections/goodbye-sale show the backdrop
if (window.location.pathname === '/collections/goodbye-sale' && !goodbyeSaleCookie && !isGoodbyeKlaviyoDisabled()) {

  const disallowUtmMediums = [
    'email',
    'sms',
  ];
  // Get the value of the utm_medium parameter from the URL
  const urlParams = new URLSearchParams(window.location.search);
  const utmMedium = urlParams.get("utm_medium");

  const isUtmMediumDisallowed = disallowUtmMediums.includes(utmMedium);

  if (isUtmMediumDisallowed) {
    document.cookie = '_goodbye_sale=true;path=/';
  } else {
    initGoodbyeSalePopup();
  }
}

/*
 * Search
 * ---------------------
 * Input focus and predictive search
 *
 */

const searchToggle = document.querySelector('[data-expander-toggle="search"]');
const searchTarget = document.querySelector('[data-expander-target="search"]');
const searchInput = searchTarget.querySelector('input[type="search"]');
const searchClose = searchTarget.querySelector('[data-expander-close]');
const searchSuggestions = document.querySelector('[data-search-suggestions]');

const searchTrapFocus = createFocusTrap(searchTarget, {
  initialFocus: false,
  allowOutsideClick: true,
});

// Focus input on search flyout expanded
searchToggle.addEventListener('click', () => {
  if (searchTarget.getAttribute('aria-expanded') == 'true') {
    searchSuggestions.innerHTML = '';
    searchTrapFocus.activate();
    searchInput.focus();
  }``
});

// Predictive search
let previousSearch;

function predictiveSearch(term) {
  previousSearch = previousSearch !== undefined ? previousSearch : '';

  if (term && term !== previousSearch) {
    fetch(
      '/search/suggest.json?q=' +
        term +
        '&resources[type]=product,page,article&resources[limit]=12&resources[options][fields]=title,product_type,variants.title,body,tag'
    )
      .then((response) => response.json())
      .then((suggestions) => {
        const productSuggestions = suggestions.resources.results.products;
        const pageSuggestions = suggestions.resources.results.pages;
        const articleSuggestions = suggestions.resources.results.articles;

        if (productSuggestions.length || pageSuggestions.length || articleSuggestions.length) {
          let suggestionsList = '';

          productSuggestions.forEach((item) => {
            if (
              item.price > 0 &&
              item.type !== 'GWP' &&
              !item.tags.includes('locked-product')
            ) {
              let imageURL =
                'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_medium.png?format=webp&v=1530129081'; // Default if no image
              const imageWidth = 250; // Also height for square image
              let variantTitle = '';

              function renderSuggestion(title, url, variant, imageURL) {
                return `
                  <li>
                    <a href="${url}" class="flex flex-col">
                      <div class="mb-2">
                        <img src="${imageURL}" alt="${title}" width="${imageWidth}" height="${imageWidth}">
                      </div>
                      <h4 class="text-sm leading-tight font-bold">${title}</h4>
                      <p class="my-1 text-xs leading-tight text-gray-700">${variant}</p>
                    </a>
                  </li>
                `;
              }

              if (item.variants.length > 0) {
                item.variants.forEach((variant) => {
                  if (variant.featured_image.url) {
                    imageURL = variant.featured_image.url
                      .replace('.png', `_${imageWidth}x.png`)
                      .replace('.jpg', `_${imageWidth}x.jpg`);
                    variantTitle = variant.title;
                  }
                });
              } else {
                if (item.featured_image.url) {
                  imageURL = item.featured_image.url
                    .replace('.png', `_${imageWidth}x.png`)
                    .replace('.jpg', `_${imageWidth}x.jpg`);
                }
              }

              suggestionsList += renderSuggestion(
                item.title,
                item.url,
                variantTitle,
                imageURL
              );
            }
          });

          let pageList = '';
          pageSuggestions.forEach((item, index) => {
            if (index === 0) {
              pageList += `<h5 class="border-b border-gray-300 pb-1 mb-1 text-xs font-bold uppercase text-gray-700">Pages</h5><ul>`;
            }
            pageList += `<li><a class="text-sm py-1 block hover:text-accent hover:underline" href="${item.url}">${item.title}</a></li>`;
            if(index == pageSuggestions.length - 1) {
              pageList += `</ul>`;
            }
          });

          let articleList = '';
          articleSuggestions.forEach((item, index) => {
            if (index === 0) {
              articleList += `<h5 class="border-b border-gray-300 pb-1 mb-1 text-xs font-bold uppercase text-gray-700">Articles</h5><ul>`;
            }
            articleList += `<li><a class="text-sm py-1 block hover:text-accent hover:underline" href="${item.url}">${item.title}</a></li>`;
            if(index == articleSuggestions.length - 1) {
              articleList += `</ul>`;
            }
          });

          if (articleList || pageList) {
            let linksPlacementClass = '';
            if (productSuggestions.length >= 4) {
              linksPlacementClass =
                'row-start-2 md:row-start-1 col-start-2 md:col-start-5 lg:col-start-6';
            }

            const linksList = `
              <li class="font-display space-y-4 bg-gray-100 p-4 ${linksPlacementClass}">
                ${pageList ? `<div>${pageList}</div>` : ''}
                ${articleList ? `<div>${articleList}</div>` : ''}
              </li>
            `;

            suggestionsList += linksList;            
          }

          searchSuggestions.innerHTML = suggestionsList;
        } else {
          searchSuggestions.innerHTML = '';
        }
      });
  }
}

searchInput.addEventListener('keyup', () => {
  if (searchInput.value.length > 2) predictiveSearch(searchInput.value);
});

/**
 * Newsletter Popup
 */
const newsletterPopup = document.querySelector('[data-newsletter-popup]');
const newsletterPopupClose = document.querySelector(
  '[data-newsletter-popup-close]'
);

if (newsletterPopup && newsletterPopupClose) {
  newsletterPopupClose.addEventListener('click', (e) => {
    newsletterPopup.remove();
    localStorage.setItem('kosas_supress_newsletter_popup', true);
  });
}

if (
  newsletterPopup &&
  !localStorage.getItem('kosas_supress_newsletter_popup')
) {
  newsletterPopup.classList.remove('hidden');
  setTimeout(function () {
    newsletterPopup.classList.remove('opacity-0');
  }, 100);
}

/**
 * Currency
 */
function currencyFormSubmit(event) {
  event.target.form.submit();
}

document
  .querySelectorAll('.shopify-currency-form select')
  .forEach(function (item) {
    item.addEventListener('change', currencyFormSubmit);
  });

// Common a11y fixes
focusHash();
bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className =
    document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
}

class HelloBar extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll('.hello-bar__item');
    if (this.items.length <= 1) return;

    this.speed = this.dataset.transitionSpeed * 1000;
    this.currentItem = 0;

    this.items[this.currentItem].classList.add('hello-bar__item--active');

    // setinterval based on speed
    setInterval(() => {
      this.changeItem();
    }, this.speed);

    this.bindEditorEvents();
  }

  changeItem() {
    const oldItem = this.items[this.currentItem];

    // Update current item
    this.currentItem = this.currentItem + 1;
    if (this.currentItem >= this.items.length) {
      this.currentItem = 0;
    }
    const newItem = this.items[this.currentItem];

    // Animate
    newItem.classList.add('hello-bar__item--active');
    oldItem.classList.remove('hello-bar__item--active');
    newItem.style.bottom = '0px';
    
    setTimeout(() => {    
      newItem.style.position = 'relative';
      oldItem.style.bottom = '-100%';
      oldItem.style.position = 'absolute';
    }, 500);
  }

  bindEditorEvents() {

    this.addEventListener('shopify:block:select', (event) => {
      
      const blockId = event.detail.blockId;
      const activeBlock = document.querySelector(`[data-block-id="${blockId}"]`);
      if (activeBlock) {
        activeBlock.classList.add('hello-bar__item--active-editor');
      }
    });

    this.addEventListener('shopify:block:deselect', (event) => {
      
      const blockId = event.detail.blockId;
      const activeBlock = document.querySelector(`[data-block-id="${blockId}"]`);
      if (activeBlock) {
        activeBlock.classList.remove('hello-bar__item--active-editor');
      }
    });
  }
}
customElements.define('hello-bar', HelloBar);

/**
  Product Grid
*/
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('[data-product-grid-form]');
      this.submitButton = this.querySelector('[data-submit-button]');
      this.submitButtonText = this.querySelector('[data-submit-button-text]');

      this.imageWidth = 400;
      this.productId = this.dataset.id;

      // Products with Preset Variants (no choice)
      if (this.dataset.variantId) {
        const currentVariant = Number(this.dataset.variantId);
        this.submitButton.addEventListener('click', (e) => {
          
          const isBundleBuilder = this.dataset.bundleBuilder === 'true';
          const BundleBuilder = this.closest('bundle-builder');


          if (isBundleBuilder && BundleBuilder) {
            const productImage = this.querySelector('.grid-view-item__image');
            const productImageSrc = productImage.getAttribute('src');

            const shadeTitle = this.querySelector('[data-shade-title]');
            let shadeTitleText = '';
            if (shadeTitle) {
              shadeTitleText = shadeTitle.innerText;
            }

            // Check for bundle index (stepped bundle builder)
            const builderProducts = this.closest('.builder__products');
            const bundleIndex = parseInt(builderProducts.dataset.bundleIndex);

            // console.log('get price', this, this.form);
            BundleBuilder.addProductToBundle({
              variantId: currentVariant,
              title: this.dataset.title,
              type: this.dataset.type,
              price: this.dataset.price,
              image: productImageSrc,
              shade: shadeTitleText,
              bundleIndex: bundleIndex,
            });

            this.submitButton.blur();
          } else {
            this.closeActiveForm();
            Cart.addItem(currentVariant, {}, 'product card');
          }
        });
        return;
      }
      if (this.submitButton) {
        this.init();
      }
    }

    async init() {
      // Get the cart action style (atc, sets, shade, link)
      this.atcAction = this.submitButton.dataset.atcAction;
      this.productCardStyle = this.dataset.style;

      if(this.productCardStyle === 'sets') {
        this.initProductSets();
      } else {
        this.initAddToCart();
        this.initProductCard();
      }
    }

    async initProductCard() {
      if (this.productCardInit) return;
      this.productCardInit = true;

      this.product = await this.getProductJson();
      this.updateOptions();
      this.addEventListener('change', this.onVariantChange);

      // first available variant id
      this.currentVariantObj = this.product.variants.find(variant => {
        return variant.available;
      });
      if (this.currentVariantObj) {
        this.currentVariant = this.currentVariantObj.id;
        this.form.dataset.variantId = this.currentVariant;
      }
    }

    async initProductSets() {
      this.product = await this.getProductJson();

      this.imageWidth = 160;
      window.addEventListener('load', () => {
        this.preloadShadeImages();
      });

      this.updateOptions();

      if (this.productCardStyle === 'sets') {
        window.localRecommendedShades = JSON.parse(
          localStorage.getItem('ShadeRecommendations')
        );
        if (window.localRecommendedShades) {
          this.applyQuizShadeRecommendations();
        }
      }

      this.addEventListener('change', this.onVariantChange);

      // first available variant id
      this.currentVariantObj = this.product.variants.find(variant => {
        return variant.available;
      });
      this.currentVariant = this.currentVariantObj.id;
      this.form.dataset.variantId = this.currentVariant;

      // Preset shades for bundles
      if (this.dataset.presetShade) {
        const presetShade = this.dataset.presetShade;

        const presetShadeVariant = this.product.variants.find(
          (variant) => variant.option1 === presetShade
        );

        if (presetShadeVariant) {
          this.currentVariant = presetShadeVariant.id;
          this.form.dataset.variantId = this.currentVariant;

          const newActiveRadio = this.querySelector(
            `input.single-option-selector__radio[value="${presetShade}"]`
          )
          newActiveRadio.click();
        }
      }
    }

    initAddToCart() {
      if (this.atcInitialized) return;

      this.atcInitialized = true;
      this.submitButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeActiveForm();

        this.atcAction = this.submitButton.dataset.atcAction;

        // If atcAction is link OR product data hasn't loaded, redirect to product page
        if (this.atcAction === 'shade' && this.product) {
          this.form.classList.remove('hidden');
          this.form.classList.add('active');
          this.submitButton.dataset.atcAction = 'atc';

          this.renderActiveVariant();
          const firstInput = this.querySelectorAll('.swatch-container input')[0];
          firstInput.focus();

          // For bundle builder
          const firstEnabledInput = this.querySelector('.swatch-container[data-disabled="false"] input');
          if (firstEnabledInput) {
            firstEnabledInput.click();
          }

          if (!isInViewport(this)) {
            this.scrollIntoView({
              block: 'start',
            });
          }

          this.preloadShadeImages();
          this.localizationChanges();

          const swiperContainer = this.closest('[data-swiper-container]');
          if (swiperContainer) {
            swiperContainer.swiper.update();
          }
        } else if (this.atcAction === 'atc') {
          const currentVariant = parseInt(this.form.dataset.variantId);

          const BundleBuilder = this.closest('bundle-builder');
          const isBundleBuilder = this.dataset.bundleBuilder === 'true';

          const properties = {};
          if (this.dataset.recommendationAttribution) {
            properties._attribution = this.dataset.recommendationAttribution;
          }
          if (this.dataset.recommendationWidgetId) {
            properties._widget_id = this.dataset.recommendationWidgetId;
          }
          if (this.dataset.recommendationSource) {
            properties._source = this.dataset.recommendationSource;
          }
          if (isBundleBuilder && BundleBuilder) {
            const productImage = this.querySelector('.grid-view-item__image');
            const productImageSrc = productImage.getAttribute('src');

            const shadeTitle = this.querySelector('[data-shade-title]');
            let shadeTitleText = '';
            if (shadeTitle) {
              shadeTitleText = shadeTitle.innerText;
            }
            // Check for bundle index (stepped bundle builder)
            const builderProducts = this.closest('.builder__products');
            const bundleIndex = parseInt(builderProducts.dataset.bundleIndex);

            // console.log('get price', this, this.form);
            BundleBuilder.addProductToBundle({
              variantId: currentVariant,
              title: this.dataset.title,
              type: this.dataset.type,
              price: this.dataset.price,
              image: productImageSrc,
              shade: shadeTitleText,
              bundleIndex,
            });

            this.submitButton.blur();
          } else {
            Cart.addItem(
              currentVariant,
              {
                properties,
              },
              'product card'
            );
          }
        } else {
          window.location.href = this.dataset.url;
        }
      });
    }

    localizationChanges() {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Restrictions for Glow I.V. in UK and EU
      const ukAndEuTimezones = [
        'Europe/Amsterdam',
        'Europe/Andorra',
        'Europe/Astrakhan',
        'Europe/Belgrade',
        'Europe/Berlin',
        'Europe/Bratislava',
        'Europe/Brussels',
        'Europe/Budapest',
        'Europe/Busingen',
        'Europe/Copenhagen',
        'Europe/Dublin',
        'Europe/Gibraltar',
        'Europe/Guernsey',
        'Europe/Helsinki',
        'Europe/Isle_of_Man',
        'Europe/Istanbul',
        'Europe/Jersey',
        'Europe/Kaliningrad',
        'Europe/Kiev',
        'Europe/Kirov',
        'Europe/Lisbon',
        'Europe/Ljubljana',
        'Europe/London',
        'Europe/Luxembourg',
        'Europe/Madrid',
        'Europe/Malta',
        'Europe/Mariehamn',
        'Europe/Minsk',
        'Europe/Monaco',
        'Europe/Moscow',
        'Europe/Oslo',
        'Europe/Paris',
        'Europe/Podgorica',
        'Europe/Prague',
        'Europe/Riga',
        'Europe/Rome',
        'Europe/Samara',
        'Europe/San_Marino',
        'Europe/Sarajevo',
        'Europe/Saratov',
        'Europe/Simferopol',
        'Europe/Skopje',
        'Europe/Sofia',
        'Europe/Stockholm',
        'Europe/Tallinn',
        'Europe/Ulyanovsk',
        'Europe/Uzhgorod',
        'Europe/Vaduz',
        'Europe/Vatican',
        'Europe/Vienna',
        'Europe/Vilnius',
        'Europe/Volgograd',
        'Europe/Warsaw',
        'Europe/Zagreb',
        'Europe/Zaporozhye',
        'Europe/Zurich',
      ];
      const ukAndEUCurrencyCodes = ['EUR', 'BGN', 'CZK', 'HUF', 'PLN', 'RON', 'SEK', 'GBP', 'DKK'];
      const hideRestrictedMessage = sessionStorage.getItem(
        'hideRestrictedMessage'
      );
      if (
        this.product.title === 'Glow I.V.'
      ) {
        if (ukAndEuTimezones.includes(timezone) || ukAndEUCurrencyCodes.includes(Shopify.currency.active)) {
          const existingMessage = this.querySelector('.grid-view-item__restricted-message');
          if (!existingMessage) {
            const restrictedMessage = document.createElement('div');
            restrictedMessage.classList.add(
              'grid-view-item__restricted-message',
              'text-xs',
              'md:text-sm',
              'text-center',
              'mt-1',
              'pointer-events-auto',
              'w-full',
              'flex',
              'flex-wrap',
              'flex-col'
            );
            restrictedMessage.innerHTML = `<span>Unavailable to ship to the UK and EU</span>
               <a href="#" class="underline" data-show-restrictions>Shipping outside of the UK & EU?</a>`;
            this.form.appendChild(restrictedMessage);
          }

          this.submitButton.style.cursor = 'not-allowed';
          this.submitButton.style.pointerEvents = 'all';
          this.submitButton.setAttribute('disabled', true);
          this.submitButton.dataset.restricted = true;

          const showRestrictions = this.querySelector('[data-show-restrictions]');
          if (showRestrictions) {
            showRestrictions.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const restrictedMessage = this.querySelector('.grid-view-item__restricted-message');
              restrictedMessage.classList.add('hidden');

              this.submitButton.style.cursor = '';
              this.submitButton.style.pointerEvents = '';
              this.submitButton.removeAttribute('disabled');
              this.submitButton.removeAttribute('restricted');

              sessionStorage.setItem('hideRestrictedMessage', true);
            });
          }
        }
      }
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value;
      });
    }

    async getProductJson() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    onVariantChange(event) {
      this.currentLabel = event.target.dataset.label || '';
      this.currentFillWeight = event.target.dataset.fillWeight || '';

      this.updateOptions();
      this.updateMasterId();
      this.renderActiveVariant();
      
      if (this.productCardStyle === 'sets') {
        this.updateShadeRecommendations();
        this.renderBundleSubmitButton();
      }
    }

    renderActiveVariant() {
      this.currentVariantData = this.product.variants.find((variant) => {
        return variant.id === this.currentVariant;
      });

      this.renderImages();
      this.renderLabel();
      this.renderDetails();
      this.renderPrice();
      this.renderSubmitButton();
    }

    applyQuizShadeRecommendations() {

      let matchingProducts = [];
      window.localRecommendedShades.forEach((recommendedShade) => {
        matchingProducts.push(recommendedShade.recommendedProduct);
      });

      if (matchingProducts.includes(this.product.handle)) {
        const matchingRecommendation = window.localRecommendedShades.find(
          (recommendedShade) => {
            return recommendedShade.recommendedProduct === this.product.handle;
          }
        );
        
        const matchingVariant = this.product.variants.find((variant) => {
          return variant.id === Number(matchingRecommendation.recommendedVariants[0]);
        });
        const matchingShade = matchingVariant.option1;
        const matchingSwatchContainer = this.querySelector(
          `.swatch-container[data-value="${matchingShade}"]`
        );
        matchingSwatchContainer.classList.add('recommended-shade');
        const matchingInput = matchingSwatchContainer.querySelector('input');        

        const recommendationsLabel = this.parentNode.querySelector('[data-sets-shade-recommendations]');
        if (recommendationsLabel) {
          recommendationsLabel.classList.remove('hidden');
          const recommendationsSourceLabel = recommendationsLabel.querySelector('[data-shade-recommendations-source]');
          recommendationsSourceLabel.innerHTML = ` - Based on Shade Match Quiz. <a href="/pages/complexion-shade-finder-quiz" class="underline font-bold hover:text-accent">Retake Quiz</a>`;
        }
      }
    }

    updateShadeRecommendations() {
      // TODO: Update once recommendations are finalized
      return;
      if (window.localRecommendedShades) return;

      const productMetafieldData = window[`product${this.product.id}MetafieldData`];
      const productCardIndex = Array.from(this.parentNode.children).indexOf(this);
      const currentVariantId = this.form.dataset.variantId;
      const currentVariantMetafieldData = productMetafieldData[currentVariantId];

      const allProductCards = [...this.parentNode.querySelectorAll('product-card')];

      // If the metafield data is empty, return
      if (
        Object.keys(currentVariantMetafieldData).length === 0 &&
        currentVariantMetafieldData.constructor === Object
      ) return;

      const previousRecommendations =
        this.parentNode.querySelectorAll('.recommended-shade');
      previousRecommendations.forEach((recommendation) => {
        recommendation.classList.remove('recommended-shade');
      });

      // loop through nextProductCards and look for a match
      allProductCards.forEach((productCard) => {
        // Loop through currentVariantMetafieldData object entries
        Object.entries(currentVariantMetafieldData).forEach(([key, value]) => {
          if (
            productCard.dataset.id !== value.product_id ||
            typeof productCard.product === 'undefined'
          )
            return;

          // If a match is found, update the product card
          const recommededVariants = value.variant_id.split(',');
          const matchingVariants = productCard.product.variants.filter(
            (variant) => {
              if (recommededVariants.includes(variant.id.toString())) {
                return variant;
              }
            }
          );

          if (matchingVariants.length === 0) return;

          matchingVariants.forEach((variant) => {
            const swatchContainer = productCard.querySelector(
              `.swatch-container[data-value="${variant.option1}"]`
            );
            swatchContainer.classList.add('recommended-shade');
          });
        });
      });

      
      // Update recommended label
      const recommendationsLabel = this.parentNode.querySelector('[data-sets-shade-recommendations]');
      if (recommendationsLabel) {
        const activeRecommendations = this.parentNode.querySelectorAll(
          '.recommended-shade'
        );
        if (activeRecommendations.length === 0) {
          recommendationsLabel.classList.add('hidden');
        } else {
          recommendationsLabel.classList.remove('hidden');

          const recommendationSourceTitle = this.dataset.title;
          const recommendationSourceVariant = this.currentVariantData.title;
          const recommendationsSourceLabel = recommendationsLabel.querySelector('[data-shade-recommendations-source]');
          recommendationsSourceLabel.innerHTML = ` - Based on <strong>${recommendationSourceTitle} - ${recommendationSourceVariant}</strong> selected.`;
        }
      }
    }

    renderImages() {
      const variantId = this.currentVariantData.id;
      const productVariant = this.product.variants.find((variant) => {
        return variant.id === variantId;
      });
      const newImage = productVariant.featured_image;

      const productImage = this.querySelector('[data-primary-image] img');
      this.imageWidth = Math.min(productImage.offsetWidth * 2, 400);

      productImage.src = `${newImage.src}&width=${this.imageWidth}`;
      productImage.alt = newImage.alt;
      productImage.removeAttribute('lazysrcset');
      productImage.removeAttribute('srcset');
      productImage.removeAttribute('data-srcset');
    }

    renderLabel() {
      // Update label
      const productLabel = this.querySelector('[data-shade-description]');
      if (this.currentLabel !== undefined) {
        productLabel.innerHTML = this.currentLabel;
      }

      const productFillWeightLabel = this.querySelector('[data-fill-weight]');
      if (this.currentFillWeight !== undefined && productFillWeightLabel) {
        productFillWeightLabel.innerHTML = this.currentFillWeight;
      }
    }

    renderDetails() {
      // Update details
      let shadeFieldset = this.querySelector(
        `fieldset[data-option-name="Shade"]`
      );
      shadeFieldset = shadeFieldset
        ? shadeFieldset
        : this.querySelector(`fieldset[data-option-name="Scent"]`);
      const optionId = `option${shadeFieldset.dataset.optionIndex}`;
      
      this.form.dataset.variantId = this.currentVariant;

      const shade = this.currentVariantData[optionId];
      const shadeTitle = this.querySelector('[data-shade-title]');
      if (shadeTitle) {
        shadeTitle.innerHTML = shade;
      }
    }

    renderPrice() {
      const price = this.querySelector('[data-sale-price]');
      const compareAtPrice = this.querySelector('[data-compare-price]');
      const compareAtText = this.querySelector('[data-compare-text]');

      this.dataset.price = this.currentVariantData.price;

      price.innerText = theme.formatMoney(
        this.currentVariantData.price,
        theme.moneyFormat
      );

      const friendsSale = this.querySelector('.price-item--friends-sale');
      if (friendsSale) {
        friendsSale.innerText = theme.formatMoney(
          this.currentVariantData.price * 0.8,
          theme.moneyFormat
        );
      }

      if (!this.compareAtPrice || !this.compareAtText) return;

      if (this.currentVariant.compare_at_price > this.currentVariantData.price) {
        this.compareAtPrice.innerText = theme.formatMoney(
          this.currentVariant.compare_at_price,
          theme.moneyFormat
        );
        this.compareAtPrice.classList.remove('hidden');
        this.compareAtText.classList.remove('hidden');
      } else {
        this.compareAtPrice.innerText = '';
        this.compareAtPrice.classList.add('hidden');
        this.compareAtText.classList.add('hidden');
      }
    }

    renderSubmitButton() {
      if (this.submitButton.dataset.restricted) return;
      const isBundleBuilder = this.dataset.bundleBuilder === 'true';

      if(!this.currentVariantData) {
        this.submitButton.disabled = true;
        this.submitButtonText.innerText = theme.strings.unavailable;
        this.submitButton.classList.remove('active');
      } else if (this.currentVariantData.available && !isBundleBuilder) {
        this.submitButton.disabled = false;
        this.submitButtonText.innerText = theme.strings.addToCart;
        this.submitButton.dataset.atcAction = 'atc';
        this.submitButton.classList.add('active');
      } else if (this.currentVariantData.available && isBundleBuilder) {
        this.submitButton.disabled = false;
        this.submitButtonText.innerText = theme.strings.addToBundle;
        this.submitButton.dataset.atcAction = 'atc';
        this.submitButton.classList.add('active');
      } else {
        this.submitButton.disabled = true;
        this.submitButtonText.innerText = theme.strings.soldOut;
        this.submitButton.classList.add('active');
      }

      const productTemplate = this.closest('product-template');
      const productSetsButton = productTemplate?.querySelector(
        '[data-product-single-form="sets"] [data-submit-button]'
      );
      if (productSetsButton) {
        const productCards = productTemplate.querySelectorAll('product-card[data-style="sets"]');
        let soldOutSet = false;
        productCards.forEach((productCard) => {
          const form = productCard.querySelector('[data-product-grid-form]');
          const currentVariant = Number(form.dataset.variantId);

          const currentVariantData = productCard.product.variants.find(
            (variant) => {
              return variant.id === currentVariant;
            }
          );
          if (currentVariantData.available === false) {
            soldOutSet = true;
          }
        });
        

        const productSetsButtonText = productSetsButton.querySelector(
          '[data-submit-button-text]'
        );
        if (soldOutSet) {
          productSetsButton.disabled = true;
          productSetsButton.classList.remove('active');
          productSetsButtonText.innerText = theme.strings.soldOut;
        } else {
          productSetsButton.disabled = false;
          productSetsButton.classList.add('active');
          productSetsButtonText.innerText = theme.strings.addToCart;
        }
      }

    }

    renderBundleSubmitButton() {
      const bundleProductCards = this.parentElement.querySelectorAll('product-card');
      const bundleAddToCartButton = this.parentElement.querySelector('button[data-type="bundle"]');
      if (!bundleAddToCartButton) return;
      const bundleAddToCartButtonText = bundleAddToCartButton.querySelector(
        '[data-submit-button-text]'
      );

      // Sold out
      const disabledProducts = [];
      bundleProductCards.forEach((productCard) => {
        const addToCartButton = productCard.querySelector('[data-submit-button]');
        if (addToCartButton.disabled) {
          disabledProducts.push(productCard);
        }
      });

      if (disabledProducts.length > 0) {
        bundleAddToCartButton.disabled = true;
        bundleAddToCartButton.classList.remove('active');
        bundleAddToCartButtonText.innerText = theme.strings.soldOut;
      } else {
        bundleAddToCartButton.disabled = false;
        bundleAddToCartButton.classList.add('active');
        bundleAddToCartButtonText.innerText = theme.strings.addToCart;
      }
    }

    updateMasterId() {
      const variants = this.product.variants;
      const activeVariantTitle = this.options.join(' / ');
      const activeVariant = variants.find((variant) => {
        return variant.title === activeVariantTitle;
      });
      
      this.currentVariant = activeVariant.id;
    }

    preloadShadeImages() {
      const productImage = this.querySelector('[data-primary-image] img');
      this.imageWidth = Math.min(productImage.offsetWidth * 2, 400);

      this.product.variants.forEach((variant) => {
        const image = variant.featured_image;
        const imageSrc = `${image.src}&width=${this.imageWidth}`;
        
        const img = new Image();
        img.src = imageSrc;
      });
    }

    closeActiveForm() {
      const activeProductForms = document.querySelectorAll('[data-product-grid-form].active');

      activeProductForms.forEach((productForm) => {
        if (productForm === this.form) return;

        productForm.classList.remove('active');
        productForm.classList.add('hidden');

        const productCard = productForm.closest('product-card');
        const submitButton = productCard.querySelector('[data-submit-button]');
        const submitButtonText = productCard.querySelector('[data-submit-button-text]');

        submitButton.dataset.atcAction = 'shade';
        submitButton.classList.remove('active');
        submitButtonText.innerText = submitButton.dataset.defaultText;

        submitButton.style.cursor = '';
        submitButton.style.pointerEvents = '';
        // remove attribute
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('data-restricted');
      });
    }
  }
  customElements.define('product-card', ProductCard);
}

if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      Cart.initCart();

      this.bindEditorEvents();
    }

    bindEditorEvents() {

      document.addEventListener('shopify:section:select', (event) => {
        const sectionId = event.detail.sectionId;

        if (sectionId === this.sectionId) {
          Cart.openCartDrawer();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        const sectionId = event.detail.sectionId;

        if (sectionId === this.sectionId) {
          Cart.closeCartDrawer();
        }
      });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
  Bundle Builder
*/
class BundleBuilder extends HTMLElement {
  constructor() {
    super();

    const bundleEncoded = this.dataset.bundle;
    if (bundleEncoded) {
      // Decode base64
      const bundleDataArray = atob(bundleEncoded).split('|');
      this.bundleData = {
        size: parseInt(bundleDataArray[0]),
        discount: parseInt(bundleDataArray[1]),

        allowDuplicateProducts: bundleDataArray[2] === 'true',
        allowDuplicateSkus: bundleDataArray[3] === 'true',
        enableSmallBundle: bundleDataArray[4] === 'true',
        smallSize: parseInt(bundleDataArray[5]),
        smallDiscount: parseInt(bundleDataArray[6]),
      };

      if (this.bundleData.enableSmallBundle) {
        this.bundleData.largeSize = this.bundleData.size;
        this.bundleData.largeDiscount = this.bundleData.discount;
        // Reset default size and discount
        this.bundleData.size = this.bundleData.smallSize;
        this.bundleData.discount = this.bundleData.smallDiscount;
      }
    }
    this.blocks = window.bundleBuilderBlocks;

    this.products = [];
    this.price = 0;
    this.compareAtPrice = 0;

    this.addToCartButton = this.querySelector('.bundle__add-to-cart');
    this.addToCartButton.addEventListener(
      'click',
      this.addBundleToCart.bind(this)
    );

    this.isBrowQuizPage = document.querySelector('body.page-brow-quiz');

    // Check if localStorage has a bundle
    const localStorageBundle = localStorage.getItem(
      `bundle_${this.dataset.productId}`
    );
    // Check if this lives on the brow quiz page
    if (localStorageBundle && !this.isBrowQuizPage) {
      const localStorageBundleData = JSON.parse(localStorageBundle);
      this.products = localStorageBundleData;
      this.updateProductSelections();
    }

    const selectionBlocks = this.blocks.filter(
      (block) => block.type === 'bundle_selection' || block.type === 'fixed_selection'
    )
    const fixedSelectionBlocks = selectionBlocks.filter(
      (block) => block.type === 'fixed_selection'
    );

    // Loop through each fixed selection block and output the index it lives at in this.blocks
    fixedSelectionBlocks.forEach((block) => {
      const index = selectionBlocks.indexOf(block) + 1;
      const product = block.settings.product_list[0];
      const title = product.title;
      const type = product.type;
      const image = `${product.featured_image}&width=960`;
      const currentVariant = product.variants[0]; 
      const price = currentVariant.price;
      const shade = currentVariant.option1;

      // check if this product is already in the bundle
      const productAlreadyInBundle = this.products.some((product) => {
        return product.variantId === currentVariant.id;
      });

      if (!productAlreadyInBundle) {
        this.addProductToBundle({
          variantId: currentVariant.id,
          title,
          type,
          price,
          image,
          shade,
          bundleIndex: index,
          isFixed: true,
        });
      }
    });

    // Watch until all product cards are loaded and have the product-options element inside
    const productCards = this.querySelectorAll('product-card');
    const productCardsLoaded = setInterval(() => {
      let allLoaded = true;
      productCards.forEach((productCard) => {
        if (!productCard.querySelector('product-options')) {
          allLoaded = false;
        }
      });

      if (allLoaded) {
        clearInterval(productCardsLoaded);
        this.updateProductSelections();
      }
    }, 100);

    const builderSteps = this.querySelector('.builder__steps');
    if (builderSteps) {
      this.initStepEvents();
      if (this.products.length === selectionBlocks.length) {
        this.updateStep(selectionBlocks.length, 'products');
        // Reduce all product cards opacity
        const productCards = this.querySelectorAll('product-card');
        productCards.forEach((productCard) => {
          productCard.dataset.disabled = true;
        });
      }
    }
    

    const revealElements = this.querySelectorAll(
      '.builder__steps, .builder__products'
    );
    revealElements.forEach((revealElement) => {
      revealElement.style.opacity = 1;
    });
  }

  initStepEvents() {
    const steps = this.querySelectorAll('.builder__steps a');
    steps.forEach((step) => {
      step.addEventListener('click', (event) => {
        event.preventDefault();
        
        const bundleIndex = step.dataset.bundleIndex;
        const bundleStep = step.dataset.bundleStep;

        this.updateStep(bundleIndex, bundleStep);
      });
    });
  }

  updateStep(bundleIndex, bundleStep) {
    const bundleSteps = this.querySelectorAll('.builder__steps a');
    bundleSteps.forEach((step) => {
      step.removeAttribute('data-active');
    });

    const bundleStepLink = this.querySelector(`.builder__steps a[data-bundle-index="${bundleIndex}"]`);
    if (bundleStepLink) {
      bundleStepLink.dataset.active = true;
    }

    const bundleProducts = this.querySelectorAll(`.builder__products`);
    bundleProducts.forEach((bundleProduct) => {
      bundleProduct.classList.add('hidden');
    });

    const bundleProduct = this.querySelector(`.builder__products[data-bundle-index="${bundleIndex}"]`);
    if (bundleProduct) {
      bundleProduct.classList.remove('hidden');
    }
  }

  addProductToBundle(product) {
    if (!product) return;

    const canAddProductToBundle = () => {
      if (this.bundleData.enableSmallBundle) {
        if (this.products.length < this.bundleData.largeSize) {
          return true;
        }
      } else {
        if (this.products.length < this.bundleData.size) {
          return true;
        }
      }
    }

    if (canAddProductToBundle()) {
      this.products.push(product);
      this.updateProductSelections();
      this.closeActiveProductCard();
    }
  }

  removeProductFromBundle(product) {
    this.products = this.products.filter((item) => item !== product);
    this.updateProductSelections();
  }
  
  updateProductSelections() {
    const bundleSelections = document.querySelectorAll(
      '.bundle__selection-grid [data-selection]'
    );

    // Set the new local storage value
    localStorage.setItem(`bundle_${this.dataset.productId}`, JSON.stringify(this.products));

    // If the bundle is full, disable all product cards
    const builderProducts = document.querySelector('.builder__products');
    if (
      this.products.length === this.bundleData.size &&
      !this.bundleData.enableSmallBundle
    ) {
      builderProducts.dataset.disabled = true;
    } else if (this.products.length === this.bundleData.largeSize && this.bundleData.enableSmallBundle) {
      builderProducts.dataset.disabled = true;
    } else {
      builderProducts.removeAttribute('data-disabled');
    }

    const builderProductSteps = document.querySelectorAll('.builder__products');
    if (builderProductSteps.length > 1) {
      // check for bundleIndex that matches
      builderProductSteps.forEach((builderProductStep) => {
        const bundleIndex = parseInt(builderProductStep.dataset.bundleIndex);
        let hasBundleIndex = this.products.some(
          (product) => product.bundleIndex === bundleIndex
        );

        if (hasBundleIndex) {
          builderProductStep.dataset.disabled = true;
        } else {
          builderProductStep.removeAttribute('data-disabled');
        }
      });

      // get the first builderProductSteps element that is not disabled
      const activeBuilderProductStep = document.querySelector(
        '.builder__products:not([data-disabled])'
      );
      if (activeBuilderProductStep) {
        const bundleIndex = parseInt(activeBuilderProductStep.dataset.bundleIndex);
        const bundleStep = activeBuilderProductStep.dataset.bundleStep;
        this.updateStep(bundleIndex, bundleStep);
      }
    }

    if (this.bundleData.enableSmallBundle) {
      const bundleUpsellTitle = document.querySelector(
        '.bundle__bundle-upsell-title'
      );
      if (this.products.length === 0) {
        bundleUpsellTitle.innerText = 'empty';
      } else if (this.products.length === this.bundleData.largeSize) {
        bundleUpsellTitle.innerText = bundleUpsellTitle.dataset.upsellSuccess;
      } else {
        bundleUpsellTitle.innerText = bundleUpsellTitle.dataset.upsell;
      }
    }

    this.resetProductSelections();

    // Update bundle selections
    this.products.forEach((product, index) => {
      let bundleSelection = bundleSelections[index];
      if (product.bundleIndex > 0) {
        bundleSelection = document.querySelector(
          `.bundle__selection[data-bundle-index="${product.bundleIndex}"] [data-selection]`
        );
      }

      if (product.variantId === parseInt(bundleSelection.dataset.variantId)) return;

      // Attributes
      bundleSelection.dataset.variantId = product.variantId;
      bundleSelection.dataset.title = product.title;
      bundleSelection.dataset.shade = product.shade;
      bundleSelection.dataset.type = product.type;
      bundleSelection.dataset.price = product.price;
      bundleSelection.dataset.image = product.image;
      bundleSelection.dataset.active = true;

      // Update product title and shade
      const bundleSelectionParent = bundleSelection.closest(
        '.bundle__selection'
      );
      const title = bundleSelectionParent.querySelector(
        '[data-selection-title]'
      );
      const shade = bundleSelectionParent.querySelector(
        '[data-selection-shade]'
      );

      title.innerText = product.title;
      shade.innerText = `${
        product.shade ? `${product.shade}` : ''
      }`;
      const titleContainer =
        bundleSelectionParent.querySelector('.selection__title');
      titleContainer.classList.remove('hidden');

      // Add product image
      const imageHtml = `
        <img
          src="${product.image}"
          alt="${product.title} - ${product.shade}"
          width="600"
          height="600"
          class="selection__image absolute inset-0 bg-white object-contain max-h-[calc(100%-1.25rem)]"
          loading="lazy"
        >
      `;
      // Remove any existing images
      const existingImage = bundleSelection.querySelector('img');
      if (existingImage) existingImage.remove();
      // Add image as a new child element of bundleSelection
      bundleSelection.insertAdjacentHTML('afterbegin', imageHtml);

      const closeButton = bundleSelection.querySelector('button');
      closeButton.clickListener = () => this.removeProductFromBundle(product);

      if (product.isFixed) {
        closeButton.style.display = 'none';
      }

      closeButton.addEventListener('click', closeButton.clickListener);
    });

    // Remove disable from all product cards not matching the current products
    if (!this.bundleData.allowDuplicateProducts || !this.bundleData.allowDuplicateSkus) {
      const productCards = this.querySelectorAll('product-card');
      productCards.forEach((productCard) => {
        const productTitle = productCard.dataset.title;
        const product = this.products.find((product) => {
          return product.title === productTitle;
        });
        if (!this.bundleData.allowDuplicateProducts) {
          if (product) {
            productCard.dataset.disabled = 'true';
          } else {
            productCard.dataset.disabled = 'false';
          }
        } else if (!this.bundleData.allowDuplicateSkus) {
          const matchingProducts = this.products.filter((product) => {
            return product.title === productTitle;
          });
          if (matchingProducts.length > 0) {
            matchingProducts.forEach((matchingProduct) => {
              const productTitle = matchingProduct.title;
              const productShade = matchingProduct.shade;

              // Create an array only of the matching shades as a string
              const matchingShades = matchingProducts.map((product) => {
                return product.shade;
              });
              const matchingProductCard = this.querySelector(`product-card[data-title="${productTitle}"]`);
              // Wait until product-options exists inside of the matchingProductCard

              // Select all swatches that have a data-value that matches one of the matchingShades array strings
              const swatches =
                matchingProductCard.querySelectorAll(`[data-shade]`);
              const matchingSwatches = matchingProductCard.querySelectorAll(
                `[data-value="${matchingShades.join('"], [data-value="')}"]`
              );

              // If matchingProductCard dataset variantCount === 1 disable the product card
              if (matchingProductCard.dataset.variantCount === '1') {
                matchingProductCard.dataset.disabled = 'true';
              }

              // If matcheingProductCard only has one swatch-container--shade, disable the product card
              const swatchShadeContainers = matchingProductCard.querySelectorAll('.swatch-container--shade'); 
              if (swatchShadeContainers.length === 1) {
                matchingProductCard.dataset.disabled = 'true';
              }

              // Enable all swatches that are not in the matchingSwatches array
              // Disable all swatches that are in the matchingSwatches array
              swatches.forEach((swatch) => {
                swatch.dataset.disabled = 'false';
              });
              matchingSwatches.forEach((swatch) => {
                swatch.dataset.disabled = 'true';
              });

              // Select the first swatch that is not disabled
              const allRadioInputs = productCard.querySelectorAll('.swatch-container input');
              allRadioInputs.forEach((radioInput) => {
                radioInput.checked = false;
              });
            });
          }
        }
        
      });
    }
    
    // Add up all the prices inside the this.products array
    if (this.products.length > 0) {
      let currentPrice = 0;
      this.products.forEach((product) => {
        currentPrice += parseInt(product.price);
      });

      let discount = this.bundleData.discount;
      if (this.bundleData.enableSmallBundle) {
        if (this.products.length < this.bundleData.largeSize) {
          discount = this.bundleData.smallDiscount;
        } else if (this.products.length === this.bundleData.largeSize) {
          discount = this.bundleData.largeDiscount;
        }
      }

      this.price = currentPrice - (currentPrice * discount / 100);
      this.compareAtPrice = currentPrice;

      const priceFormatted = theme.formatMoney(
        this.price,
        theme.moneyFormat
      );
      const compareAtPriceFormatted = theme.formatMoney(
        this.compareAtPrice,
        theme.moneyFormat
      );

      const bundleTotalContainer = this.querySelector('.bundle__bundle-total');
      const bundleTotal = bundleTotalContainer.querySelector(
        '[data-bundle-total]'
      );
      const bundleTotalOriginal = bundleTotalContainer.querySelector(
        '[data-bundle-total-original]'
      );
      bundleTotalContainer.classList.remove('hidden');
      bundleTotal.innerText = priceFormatted;
      bundleTotalOriginal.innerText = compareAtPriceFormatted;

      let buttonText = `Choose ${this.bundleData.size} Products`;
      if (this.products.length >= this.bundleData.size) {
        buttonText = 'Add Bundle to Bag';
        this.addToCartButton.removeAttribute('disabled');
      }
      else if (this.products.length < this.bundleData.size) {
        buttonText = `Choose ${this.bundleData.size - this.products.length} More Product${
          this.bundleData.size - this.products.length > 1 ? 's' : ''
        }`;
      }
      this.addToCartButton.innerText = buttonText;

    }
  }

  resetProductSelections() {
    const bundleSelections = document.querySelectorAll(
      '.bundle__selection-grid [data-selection]'
    );

    // Clear out all bundle selections
    bundleSelections.forEach((bundleSelection) => {
      bundleSelection.dataset.variantId = '';
      bundleSelection.dataset.title = '';
      bundleSelection.dataset.shade = '';
      bundleSelection.dataset.type = '';
      bundleSelection.dataset.price = '';
      bundleSelection.dataset.image = '';
      bundleSelection.removeAttribute('data-active');

      const bundleSelectionParent =
        bundleSelection.closest('.bundle__selection');
      const title = bundleSelectionParent.querySelector(
        '[data-selection-title]'
      );
      const shade = bundleSelectionParent.querySelector(
        '[data-selection-shade]'
      );
      title.innerText = '';
      shade.innerText = '';
      const titleContainer =
        bundleSelectionParent.querySelector('.selection__title');
      titleContainer.classList.add('hidden');

      const existingImage = bundleSelection.querySelector('img');
      if (existingImage) existingImage.remove();

      const closeButton = bundleSelection.querySelector('button');
      if (closeButton.clickListener) {
        closeButton.removeEventListener('click', closeButton.clickListener);
        delete closeButton.clickListener;
      }
      closeButton.removeEventListener('click', this.removeProductFromBundle);

      // Hide bundle total
      const bundleTotalContainer = this.querySelector('.bundle__bundle-total');
      bundleTotalContainer.classList.add('hidden');

      // Disable add to cart button and reset text
      this.addToCartButton.disabled = true;
      this.addToCartButton.innerText = `Choose Products`;
    });
  }

  closeActiveProductCard() {
    
    const activeProductForms = document.querySelectorAll('[data-product-grid-form].active');

    activeProductForms.forEach((productForm) => {
      if (productForm === this.form) return;

      productForm.classList.remove('active');
      productForm.classList.add('hidden');

      const productCard = productForm.closest('product-card');
      const submitButton = productCard.querySelector('[data-submit-button]');
      const submitButtonText = productCard.querySelector('[data-submit-button-text]');

      submitButton.dataset.atcAction = 'shade';
      submitButton.classList.remove('active');
      submitButtonText.innerText = submitButton.dataset.defaultText;

      submitButton.style.cursor = '';
      submitButton.style.pointerEvents = '';
      // remove attribute
      submitButton.removeAttribute('disabled');
      submitButton.removeAttribute('data-restricted');
    });
    
  }

  addBundleToCart() {
    const items = [];
    const bundleProducts = [];
    const bundleIds = [];

    let discount = this.bundleData.discount;
    if (this.bundleData.enableSmallBundle) {
      if (this.products.length < this.bundleData.largeSize) {
        discount = this.bundleData.smallDiscount;
      } else if (this.products.length === this.bundleData.largeSize) {
        discount = this.bundleData.largeDiscount;
      }
    }


    this.products.forEach((product) => {
      const bundleProduct = {
        title: product.title,
        shade: product.shade,
        image: product.image,
        id: product.variantId,
      }
      bundleProducts.push(bundleProduct);
      bundleIds.push(product.variantId);

      const item = {
        id: parseInt(product.variantId),
        quantity: 1,
        properties: {
          _bundle: this.dataset.sku,
          _bundle_title: this.dataset.title,
          _bundle_sku: this.dataset.sku,
          _bundle_url: this.dataset.url,
          _bundle_id: this.dataset.variantId,
          _bundle_image: this.dataset.image,
          _bundle_price: this.price,
          _bundle_compare_at_price: this.compareAtPrice,
          _bundle_products: [],
          _d: Number((100 - discount) / 100),
        },
      };
      items.push(item);
    });

    items.forEach((item) => {
      item.properties._bundle_id = bundleIds.join(':');
      item.properties._bundle_products = bundleProducts;
    });

    Cart.addItems(items);

    // Clear out local storage
    localStorage.removeItem(`bundle_${this.dataset.productId}`);
  }
}
customElements.define('bundle-builder', BundleBuilder);

/**
  Home Hero
*/
class HomeHero extends HTMLElement {
  constructor() {
    super();

    const selectors = {
      heroVideos: '[data-hero-video-container]',
      heroVideo: '[data-hero-video]',
      heroVideoMute: '[data-hero-video-mute]',
      heroVideoUnmute: '[data-hero-video-unmute]',
    };

    const heroVideos = this.querySelectorAll(selectors.heroVideos);

    if (heroVideos.length > 0) {
      heroVideos.forEach((el) => {
        const heroVideo = el.querySelector(selectors.heroVideo);
        const heroVideoMute = el.querySelector(selectors.heroVideoMute);
        const heroVideoUnmute = el.querySelector(selectors.heroVideoUnmute);

        if (heroVideoMute) {
          heroVideoMute.onclick = function (e) {
            e.preventDefault();
            heroVideo.muted = false;
            heroVideoMute.classList.add('hidden');
            heroVideoUnmute.classList.remove('hidden');
          };
        }

        if (heroVideoUnmute) {
          heroVideoUnmute.onclick = function (e) {
            e.preventDefault();
            heroVideo.muted = true;
            heroVideoUnmute.classList.add('hidden');
            heroVideoMute.classList.remove('hidden');
          };
        }
      });
    }
  }
}
if (!customElements.get('home-hero')) {
  customElements.define('home-hero', HomeHero);
}

/**
  Home Grid
*/
class CollectionGridSlider extends HTMLElement {
  constructor() {
    super();

    const selectors = {
      swiperContainer: '[data-swiper-container]',
    };
    const swiperContainer = this.querySelector(selectors.swiperContainer);

    const fullWidth = this.dataset.fullWidth === 'true';
    // Set breakpoints based on fullWidth value
    const breakpoints = fullWidth
      ? {
          768: {
            slidesPerView: 3.5,
          },
          1024: {
            slidesPerView: 4,
          },
          1500: {
            slidesPerView: 5,
          },
        }
      : {
          768: {
            slidesPerView: 3.5,
          },
          1024: {
            slidesPerView: 3,
          },
        };

    this.swiper = new SwiperCore(swiperContainer, {
      autoHeight: true,
      observer: true,
      observeSlideChildren: true,
      slidesPerView: 2.4,
      spaceBetween: 16,
      threshold: 10,
      breakpoints: breakpoints,

      // If we need pagination
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        clickable: true,
      },

      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
}
customElements.define('collection-grid-slider', CollectionGridSlider);

/**
  Reviews - Product
*/
class ReviewsProduct extends HTMLElement {
  constructor() {
    super();

    const swiperContainer = this.querySelector('.swiper-container');
    
    this.swiper = new SwiperCore(swiperContainer, {
      autoHeight: false,
      observer: true,
      observeSlideChildren: true,
      slidesPerView: 1,
      threshold: 10,
      loop: true,
      autoplay: {
        delay: 4000,
      },

      // If we need pagination
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
    
  }
}
if (!customElements.get('reviews-product')) {
  customElements.define('reviews-product', ReviewsProduct);
}

/**
  Hero - Carousel
*/
class HeroCarousel extends HTMLElement {
  constructor() {
    super();

    const slides = this.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    this.swiper = new SwiperCore(this, {
      autoHeight: true,
      loop: true,
      autoplay: {
        delay: 4000,
      },

      // If we need pagination
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });

    // on this mouseleave start the autoplay
    this.addEventListener('mouseleave', () => {
      this.swiper.autoplay.start();
    });

    // on this mouseenter pause the autoplay
    this.addEventListener('mouseenter', () => {
      this.swiper.autoplay.stop();
    });

    // Loop through the slides looking for a .video_container video
    slides.forEach((slide) => {
      const video = slide.querySelector('.video-container video');
      if (video) {
        const muteButton = slide.querySelector('.mute-button');
        muteButton.addEventListener('click', () => {
          // Toggle the muted state
          video.muted = !video.muted;

          const muteButtonOffIcon = muteButton.querySelector('.mute-button--off');
          const muteButtonOnIcon = muteButton.querySelector('.mute-button--on');

          // Hide or show muteButtonOffIcon or muteButtonOnIcon
          if (video.muted) {
            muteButtonOffIcon.classList.add('hidden');
            muteButtonOnIcon.classList.remove('hidden');
          }
          else {
            muteButtonOffIcon.classList.remove('hidden');
            muteButtonOnIcon.classList.add('hidden');
          }
        });
      }
    });
  }

}
if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel);
}

/**
  Collection Hero
*/
class CollectionHero extends HTMLElement {
  constructor() {
    super();

    const videoContainers = this.querySelectorAll('.video-container');
    videoContainers.forEach((videoContainer) => {
      const video = videoContainer.querySelector('video');
      const muteButton = videoContainer.querySelector('.mute-button');
      const muteButtonOffIcon = muteButton.querySelector('.mute-button--off');
      const muteButtonOnIcon = muteButton.querySelector('.mute-button--on');

      video.muted = true; // Initial mute state for all videos
      muteButtonOffIcon.classList.add('hidden'); // Initially the "off" icon is hidden
      muteButtonOnIcon.classList.remove('hidden'); // Initially the "on" icon is shown

      muteButton.addEventListener('click', () => {
        video.muted = !video.muted; // Toggle the muted state for this video

        if (video.muted) {
          muteButtonOffIcon.classList.add('hidden');
          muteButtonOnIcon.classList.remove('hidden');
        } else {
          muteButtonOffIcon.classList.remove('hidden');
          muteButtonOnIcon.classList.add('hidden');
          this.muteAllOtherVideos(video);
        }
      });
    });
  }

  muteAllOtherVideos(currentVideo) {
    const videos = this.querySelectorAll('.video-container video');
    videos.forEach((video) => {
      if (video !== currentVideo) {
        video.muted = true;

        const muteButton = video.parentElement.querySelector('.mute-button');
        const muteButtonOffIcon = muteButton.querySelector('.mute-button--off');
        const muteButtonOnIcon = muteButton.querySelector('.mute-button--on');

        muteButtonOffIcon.classList.add('hidden');
        muteButtonOnIcon.classList.remove('hidden');
      }
    });
  }
}
if (!customElements.get('collection-hero')) {
  customElements.define('collection-hero', CollectionHero);
}

/**
  Image Slider
*/
class ImageSlider extends HTMLElement {
  constructor() {
    super();

    const videoContainers = this.querySelectorAll('.video-container');
    videoContainers.forEach((videoContainer) => {
      const video = videoContainer.querySelector('video');
      const muteButton = videoContainer.querySelector('.mute-button');
      const muteButtonOffIcon = muteButton.querySelector('.mute-button--off');
      const muteButtonOnIcon = muteButton.querySelector('.mute-button--on');

      video.muted = true; // Initial mute state for all videos
      muteButtonOffIcon.classList.add('hidden'); // Initially the "off" icon is hidden
      muteButtonOnIcon.classList.remove('hidden'); // Initially the "on" icon is shown

      muteButton.addEventListener('click', () => {
        video.muted = !video.muted; // Toggle the muted state for this video

        if (video.muted) {
          muteButtonOffIcon.classList.add('hidden');
          muteButtonOnIcon.classList.remove('hidden');
        } else {
          muteButtonOffIcon.classList.remove('hidden');
          muteButtonOnIcon.classList.add('hidden');
          this.muteAllOtherVideos(video);
        }
      });
    });
  }

  muteAllOtherVideos(currentVideo) {
    const videos = this.querySelectorAll('.video-container video');
    videos.forEach((video) => {
      if (video !== currentVideo) {
        video.muted = true;

        const muteButton = video.parentElement.querySelector('.mute-button');
        const muteButtonOffIcon = muteButton.querySelector('.mute-button--off');
        const muteButtonOnIcon = muteButton.querySelector('.mute-button--on');

        muteButtonOffIcon.classList.add('hidden');
        muteButtonOnIcon.classList.remove('hidden');
      }
    });
  }
}

if (!customElements.get('image-slider')) {
  customElements.define('image-slider', ImageSlider);
}


class TextSlider extends HTMLElement {
  constructor() {
    super();

    const selectors = {
      swiperContainer: '[data-swiper-container]',
    };
    const swiperContainer = this.querySelector(selectors.swiperContainer);

    this.swiper = new SwiperCore(swiperContainer, {
      autoHeight: true,
      observer: true,
      observeSlideChildren: true,
      slidesPerView: 1,
      threshold: 10,
      loop: true,
      // If we need pagination
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: false,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });

  }
}
customElements.define('text-slider', TextSlider);



class ModalAnnouncement extends HTMLElement {
  constructor() {
    super();

    const modalId = this.dataset.modalId;
    if (localStorage.getItem(modalId)) {
      return;
    }

    const selectors = {
      modal: '[data-modal]',
      modalClose: '[data-modal-close]',
    };

    const modal = this.querySelector(selectors.modal);
    const modalClose = this.querySelector(selectors.modalClose);

    // Remove the hidden class to show the modal
    this.classList.remove('hidden');

    // Add animation to slide the modal up into the current position
    modal.style.animation = 'slide-up 0.3s ease-in-out forwards';

    if (modalClose) {
      modalClose.onclick = function (e) {
        e.preventDefault();
        modal.classList.add('hidden');

        localStorage.setItem(modalId, true);
      };
    }
  }
}
customElements.define('modal-announcement', ModalAnnouncement);


class VideoContainer extends HTMLElement {
  constructor() {
    super();

    const video = this.querySelector('video');
    const muteButton = this.querySelector('.mute-button');
    const muteButtonOffIcon = muteButton.querySelector('.mute-button--off');
    const muteButtonOnIcon = muteButton.querySelector('.mute-button--on');

    video.muted = true; // Initial mute state for all videos
    muteButtonOffIcon.classList.add('hidden'); // Initially the "off" icon is hidden
    muteButtonOnIcon.classList.remove('hidden'); // Initially the "on" icon is shown

    muteButton.addEventListener('click', () => {
      video.muted = !video.muted; // Toggle the muted state for this video

      if (video.muted) {
        muteButtonOffIcon.classList.add('hidden');
        muteButtonOnIcon.classList.remove('hidden');
      } else {
        muteButtonOffIcon.classList.remove('hidden');
        muteButtonOnIcon.classList.add('hidden');
        this.muteAllOtherVideos(video);
      }
    });
  }

  muteAllOtherVideos(currentVideo) {
    const videos = document.querySelectorAll('.video-container video');
    videos.forEach((video) => {
      if (video !== currentVideo) {
        video.muted = true;

        const muteButton = video.parentElement.querySelector('.mute-button');
        const muteButtonOffIcon = muteButton.querySelector('.mute-button--off');
        const muteButtonOnIcon = muteButton.querySelector('.mute-button--on');

        muteButtonOffIcon.classList.add('hidden');
        muteButtonOnIcon.classList.remove('hidden');
      }
    });
  }
}
if (!customElements.get('video-container')) {
  customElements.define('video-container', VideoContainer);
}


// Prevent YOTPO from loading unessary scripts
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type === 'childList') {
      const iframe = mutation.addedNodes[0];
      if (iframe && iframe.id === 'swell-popup') {
        const originalAppendChild = iframe.contentDocument.head.appendChild;
        iframe.contentDocument.head.appendChild = function (node) {
          // Prevent loading into the head
          return;
        };
        observer.disconnect();
      }
    }
  });
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

const originalAppendChild = document.body.appendChild;
document.body.appendChild = function (node) {
  if (node.tagName === 'IFRAME' && node.id === 'swell-popup') {
    node.onload = null;
  }

  return originalAppendChild.apply(this, arguments);
};

/**
 * Async Load of 3rd Party resource heavy files
 * - Delays loading until scroll or touchstart
 */

// Classes to limit the script to load only on
// * - wildcard
// .template-product, .template-collection - product and collection
// .template-cart - cart

const asyncUrls = [
  {
    url: 'https://js.afterpay.com/afterpay-1.x.js',
    selector: '*',
  },
  {
    url: 'https://a.klaviyo.com/media/js/onsite/onsite.js',
    selector: '.template-product',
  },
];
let asyncLoaded = false;

if (theme.appResourceUrls) {
  theme.appResourceUrls.forEach((url) => {
    asyncUrls.push({
      url: url,
      selector: '*',
    });
  });
}

function asyncLoad() {

  // Set up a global event that other elements can listen for to know when the async load is complete
  const firstUserInteraction = new CustomEvent('firstUserInteraction');
  // Dispatch the event
  document.dispatchEvent(firstUserInteraction);
  window.firstUserInteraction = true;

  asyncLoaded = true;
  asyncUrls.forEach(function (obj) {
    const url = obj.url;
    let selector = obj.selector;
    let exclude = obj.exclude || '';

    if (selector === null || selector === undefined) {
      selector = '*';
    }

    const body = document.querySelector('body');
    const isActiveTemplate = body.matches(selector);
    let isExcludeTemplate = false;
    if (exclude !== '') {
      isExcludeTemplate = body.matches(exclude);
    }

    if (isActiveTemplate && !isExcludeTemplate) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = url;
      if (obj.id) {
        script.id = obj.id;
      }
      const tag = document.getElementsByTagName('script')[0];
      tag.parentNode.insertBefore(script, tag);
    }
  });

  onAsyncLoad();
}

function loadResources() {
  if (!asyncLoaded) {
    asyncLoad();
  }
}

// Any functionality needed post async load
async function onAsyncLoad() {

  const body = document.querySelector('body');
  const isProductTemplate = body.matches('.template-product');

  if (isProductTemplate) {
    window.klaviyoOnload = setInterval(
      function () {
        if (typeof klaviyo !== 'undefined') {
          if (klaviyo._initialized) {
            clearInterval(window.klaviyoOnload);

            klaviyo.init({
              account: 'Qs3sSt',
              platform: 'shopify',
              list: 'NwhNp5',
            });

            klaviyo.enable('backinstock', {
              trigger: {
                product_page_text: 'Email Me When Available',
                product_page_class: 'button--solid button--back-in-stock',
                product_page_text_align: 'center',
                product_page_margin: '0px',
                alternate_anchor: 'BackInStock',
                replace_anchor: false,
              },
              modal: {
                headline: '{product_name}',
                body_content:
                  'Register to receive a notification when this item comes back in stock.',
                email_field_label: 'Email',
                button_label: 'Email me when available',
                subscription_success_label:
                  "You're in! We'll let you know when it's back.",
                footer_content: '',
                drop_background_color: '#000',
                background_color: '#fff',
                text_color: '#222',
                button_text_color: '#fff',
                button_background_color: '#000000',
                close_button_color: '#ccc',
                error_background_color: '#fcd6d7',
                error_text_color: '#C72E2F',
                success_background_color: '#d3efcd',
                success_text_color: '#1B9500',
              },
            });
          }
        }
      },
      100,
      null
    );
  }
  
  // Gladly
  !function(c,n,r,t){if(!c[r]){var i,d,p=[];d="PROD"!==t&&t?"STAGING"===t?"https://cdn.gladly.qa/gladly/chat-sdk/widget.js":t:"https://cdn.gladly.com/chat-sdk/widget.js",c[r]={init:function(){i=arguments;var e={then:function(t){return p.push({type:"t",next:t}),e},catch:function(t){return p.push({type:"c",next:t}),e}};return e}},c.__onHelpAppHostReady__=function(t){if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)for(var e=t.init.apply(t,i),n=0;n<p.length;n++){var a=p[n];e="t"===a.type?e.then(a.next):e.catch(a.next)}},function(){try{var t=n.getElementsByTagName("script")[0],e=n.createElement("script");e.async=!0,e.src=d+"?q="+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}}
  (window,document,'Gladly','PROD');
  Gladly.init({
    appId: "kosas.com",
    autoShowButton: true,
  }).then(function() {

    var liveChatLinks = document.querySelectorAll('a[href="#live-chat"]');
    liveChatLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        Gladly.show();
      });
    });
  }).catch(function(error) {
    console.log('error:', error)
  });

  // // Accessibe
  // (function(){
  // var s = document.createElement('script'),
  // e = ! document.body ? document.querySelector('head') : document.body;
  // s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
  // s.async = true;
  // s.onload = function(){
  // acsbJS.init({
  // statementLink    : '',
  // footerHtml       : '',
  // hideMobile       : true,
  // hideTrigger      : true,
  // language         : 'en',
  // position         : 'left',
  // leadColor        : '#000000',
  // triggerColor     : '#000000',
  // triggerRadius    : '50%',
  // triggerPositionX : 'left',
  // triggerPositionY : 'bottom',
  // triggerIcon      : 'people',
  // triggerSize      : 'small',
  // triggerOffsetX   : 20,
  // triggerOffsetY   : 20,
  // mobile           : {
  // triggerSize      : 'small',
  // triggerPositionX : 'left',
  // triggerPositionY : 'center',
  // triggerOffsetX   : 0,
  // triggerOffsetY   : 0,
  // triggerRadius    : '0'
  // }
  // });
  // };
  // e.appendChild(s);
  // }());

  window.Shopify.loadFeatures(
   [
     {
       name: 'consent-tracking-api',
       version: '0.1',
     },
   ],
   error => {
     if (error) {
       throw error; // if you want to raise
     }
     const userCanBeTracked = Shopify.customerPrivacy.userCanBeTracked();
     if (userCanBeTracked) {
       window.tolstoyAppKey = '0828652f-8afa-4058-9008-e0543a6c6cf0'; var s =
       document.createElement('script'); s.type = 'text/javascript'; s.async = true;
       s.src = 'https://widget.gotolstoy.com/widget/widget.js';
       document.head.appendChild(s);
     }
   },
  );

  
}

// After page is fully loaded and once a user interacts
document.addEventListener('DOMContentLoaded', function (event) {
  document.addEventListener(
    'scroll',
    function (event) {
      loadResources();
    },
    {once: true}
  );

  document.addEventListener(
    'mousemove',
    function (event) {
      loadResources();
    },
    {once: true}
  );

  document.addEventListener(
    'touchstart',
    function (event) {
      loadResources();
    },
    {once: true}
  );
});

// Catch.js
// Add an event listener on the document that listens for the custom firstUserInteraction event
document.addEventListener('firstUserInteraction', async (event) => {
  // Load Catch.js
  const catchjs = await loadCatchjs({
    live: true,
  });

  catchjs.init('k41DjQol4TRSyFucVRv79xgZ', {
    theme: 'light-color',
  }).catch((error) => {
    console.error('Catch.js failed to load', error);
  }).then((catchHandle) => {
    // console.log('Catch.js loaded successfully', catchHandle);
  });
});

const getParams = function (url) {
  var params = {};
  var parser = document.createElement('a');
  parser.href = url;
  var query = parser.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
};

const params = getParams(window.location.href);
if (params.discount_code) {
  // Store data
  sessionStorage.setItem('discount_code', params.discount_code);
}

const sessionDiscountCode = sessionStorage.getItem('discount_code');
if (sessionDiscountCode) {
  window.sessionDiscountCode = sessionDiscountCode;

  const announcementBar = document.querySelector('.announcement-bar ul');
  const firstItem = announcementBar.querySelector('li:last-child');

  firstItem.innerHTML = `<a href="/discount/TRYKOSAS">Your site credit is back! Code: ${sessionDiscountCode}</a>`;
} else {
  window.sessionDiscountCode = 0;
}


window.addEventListener('message', (event) => {
  if (event.origin !== 'https://sdk.postscript.io') return;

  const setCookies = Object.keys(event.data).filter(key => key.startsWith('SetCookie'));

  if (setCookies.length > 0) {
    const setCookie = event.data.SetCookie;

    if (setCookie.name === 'ps_id') {
      const postScriptId = setCookie.status;
      window.theme.postScriptId = postScriptId;
    }

    if (setCookie.name === '_ps_twotap_id') {
      const postScriptId = setCookie.status;
      window.theme.postScriptId = postScriptId;
    }

    if (setCookie.name.includes('_ps_pop_')) {
      const popupId = parseInt(setCookie.name.split('_ps_pop_')[1]);
      window.theme.popupId = popupId;
    }
  }

  const frameDisplays = Object.keys(event.data).filter(key => key.startsWith('FrameDisplay'));
  if (frameDisplays.length > 0) {
    const frameDisplay = event.data.FrameDisplay;
    if (frameDisplay === 'none') {
      
      if (window.theme.postScriptId && window.theme.popupId) {
        if (
          window.theme.popupId === 244517 ||
          window.theme.popupId === 244515
        ) {
          window.location.href = '/pages/complexion-shade-finder-quiz';
        }
      }
    }
  }
});

// When ?qa=true add data-qa-mode to the html element
if (window.location.search.includes('qa=true')) {
  // Set session storage to true
  sessionStorage.setItem('qaMode', true);
} else if (window.location.search.includes('qa=false')) {
  // Set session storage to false
  sessionStorage.setItem('qaMode', false);
}

if (sessionStorage.getItem('qaMode') === 'true') {
  document.documentElement.setAttribute('data-qa-mode', true);
}

// Octaine AI Quiz
document.addEventListener(
  'octane.quiz.addToCart',
  (event) => {
    const {detail} = event;
    const {items} = detail;

    Cart.addItems(items);

    // Wait 1 second
    setTimeout(() => {
      const viewCartButton = document.querySelector(
        'button[title="View cart"]'
      );
      if (viewCartButton) {
        // Override click event
        viewCartButton.addEventListener(
          'click',
          (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();
            Cart.openCartDrawer();
          },
          true
        );
      }
    }, 400);
  },
  false
);

document.addEventListener(
  'octane.quiz.addToCartError',
  (event) => {
    console.error('add to cart error', event);
  },
  false
);

document.addEventListener(
  'octane.quiz.completed',
  async (event) => {
    const {detail} = event;
    console.log('quiz completed', detail);

    const url = 'https://hooks.zapier.com/hooks/catch/12118001/3hfjgx1/';

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(detail),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
      } else {
        const jsonData = await response.json();
        console.log('Success:', jsonData);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  },
  false
);

// Apply temporary solution for Tolstoy caption
async function applyTolstoyCaption() {
  await waitUntil(() => window.tolstoyWidget, {
    timeout: WAIT_FOREVER,
  });

  // find all video elements with src containing 'tolstoy'
  const videos = document.querySelectorAll('video[src*="tolstoy"]');
  videos.forEach((video) => {
    // add black background
    video.parentElement.style.backgroundColor = 'black';
  });


  console.log('tolstoy exists');
}
applyTolstoyCaption();

// Observe PostScript for Popup vs. Bubble states
function psObserveChange() {
  // Check if the viewport width is less than 490px, if true, exit the function early
  if (window.innerWidth < 481) {
    return;
  }

  const iframeSelector = 'iframe#ps__widget';
  const timerDelay = 1500;
  let timer;
  let isPopupStateOnceApplied = false; // Flag to check if popup state was applied once

  const applyClassToParentContainer = function (iframe) {
    const parentContainer = iframe.parentNode;
    if (iframe.offsetHeight > 150) {
      parentContainer.classList.add('ps-state--popup');
      parentContainer.classList.remove('ps-state--bubble');
      isPopupStateOnceApplied = true;
    } else {
      parentContainer.classList.add('ps-state--bubble');
      parentContainer.classList.remove('ps-state--popup');
    }
  };

  const handleMutations = function (mutationsList) {
    if (timer) {
      clearTimeout(timer);
    }
    // If popup state was applied once, apply the class change instantly
    if (isPopupStateOnceApplied) {
      const iframe = document.querySelector(iframeSelector);
      if (iframe) {
        applyClassToParentContainer(iframe);
      }
      return; // Exit early
    }

    // Otherwise, wait for the timer delay
    timer = setTimeout(() => {
      const iframe = document.querySelector(iframeSelector);
      if (iframe) {
        applyClassToParentContainer(iframe);
      }
    }, timerDelay);
  };

  const observeIframeChanges = function () {
    const iframe = document.querySelector(iframeSelector);
    if (iframe) {
      const observerConfig = {attributes: true, childList: true, subtree: true};
      const observer = new MutationObserver(handleMutations);
      observer.observe(iframe, observerConfig);
    } else {
      setTimeout(psObserveChange, 100);
    }
  };

  observeIframeChanges();
}

psObserveChange();






